import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { authApi } from '@/Api/auth-v2.api';
import { useAuthStore } from '@/Stores/auth-v2-store';

/**
 * Composant pour initialiser l'authentification au demarrage de l'app.
 * A placer a la racine du router.
 *
 * - Restaure la session via refreshToken au reload
 * - Redirige vers /change-password-required si necessaire
 */
export const AuthInitializer: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { requirePasswordChange, isAuthenticated, isLoading } = useAuthStore();

  useEffect(() => {
    authApi.initializeAuth();
  }, []);

  useEffect(() => {
    if (
      isAuthenticated &&
      !isLoading &&
      requirePasswordChange &&
      location.pathname !== '/change-password-required'
    ) {
      navigate('/change-password-required', { replace: true });
    }
  }, [isAuthenticated, isLoading, requirePasswordChange, location.pathname, navigate]);

  return <>{children}</>;
};
